const STEPS = {
    DECLARE_WINNER: 'DECLARE_WINNER',
    ENTER_WINNER_INFO: 'ENTER_WINNER_INFO',
    CHOOSE_PAYMENT: 'CHOOSE_PAYMENT',
    FINALIZE_WINNER: 'FINALIZE_WINNER',
};

export { STEPS };
